
import { create } from 'zustand';

const useProcessingPurposeStore = create((set) => ({
  // Data State
  purposes: [],
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  uniqueValues: {},
  columnFilters: {},

  // Status State
  loading: false,
  error: null,
  success: null,

  // UI State - Form
  isFormOpen: false,
  isEditMode: false,
  selectedPurpose: null,
  formData: { name: '', description: '' },
  formErrors: {},

  // UI State - Dialogs
  isDeleteDialogOpen: false,
  purposeToDelete: null,

  // Actions - Data
  setPurposes: (purposes) => set({ purposes }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),

  // Actions - Status
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
  clearMessages: () => set({ error: null, success: null }),

  // Actions - Form
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedPurpose: null,
    formData: { name: '', description: '' },
    formErrors: {},
    error: null,
    success: null
  }),

  openEditForm: (purpose) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedPurpose: purpose,
    formData: {
      name: purpose.name || '',
      description: purpose.description || ''
    },
    formErrors: {},
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedPurpose: null,
    formData: { name: '', description: '' },
    formErrors: {},
    error: null,
    success: null
  }),

  setFormData: (data) => set({ formData: data }),
  setFormErrors: (errors) => set({ formErrors: errors }),

  // Actions - Delete Dialog
  openDeleteDialog: (purpose) => set({
    isDeleteDialogOpen: true,
    purposeToDelete: purpose
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    purposeToDelete: null
  }),

}));

export default useProcessingPurposeStore;
